/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-decoration-12': {
    width: 48,
    height: 37,
    viewBox: '0 0 48 37',
    data: '<path pid="0" class="st0" d="M19.1 13.2c8.1 0 16.9-3 16.9-6s-1.1-8.4-10-7c-8 1.3-19 0-19.3 7-.3 3 4.3 6 12.4 6m6.4-11.4c1.5-.7 7.8-.2 8.5 2.3.5 1.5-.1 3.2-1.6 3.9-1.6.7 0-1.4-.5-3-.9-2.8-8-2.4-6.4-3.2"/><path pid="1" class="st0" d="M10.7 14c-.6 1-.7 2.3.1 4 1.5 3.2 7.8 6.4 17.4 6.4 9.6 0 17.4-2.9 17.4-6.4 0-3.1-1.7-7.1-8.6-8.1-3 3.5-11.4 5.4-17.9 5.4-3.2 0-6-.5-8.4-1.3m26.2-1.6c1.6-.7 5.3-.3 6.1 2.2.4 1.5.9 3.9-.7 4.7-1.6.7-.9-2.2-1.4-3.7-.9-2.9-5.5-2.5-4-3.2"/><path pid="2" class="st0" d="M43.3 23.5c-3.8 1.9-9.5 2.9-15.1 2.9-9 0-16.5-2.8-19-7C2.5 21 0 24.4 0 28c0 4.8 10.7 8.8 24 8.8 13.2 0 24-3.9 24-8.8 0-1.5-1.8-3.1-4.7-4.5m-23.7 9c-9.3 0-16.1-6-15.3-7 .8-1 4.1 2.3 10.2 4 10.7 2.8 23.2-.1 23.1.7-.2.8-8.7 2.3-18 2.3"/>'
  }
})
